module.exports = "query Accounts (\n  $page: Int = 1,\n  $limit: Int = 99999,\n  $asc: String = \"name\",\n  $save_users_email: Boolean,\n  $vidalink: String\n) {\n  accounts (page: $page, limit: $limit, asc: $asc, save_users_email: $save_users_email, vidalink: $vidalink) {\n    data {\n      id\n      name\n    }\n    current_page\n    from\n    to\n    per_page\n    total\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/Accounts.graphql
// module id = XXYx
// module chunks = 1624